import { LABEL } from "@/data/catalog";
import { Youtube, Instagram, Music2 } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-void border-t border-white/10 px-5 md:px-10 pt-20 pb-32 overflow-hidden">
      <div className="max-w-[1600px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 mb-16">
          <div>
            <p className="font-mono uppercase tracking-[0.3em] text-xs text-signal mb-6">[ Tune In ]</p>
            <h2 className="font-display uppercase leading-[0.82] tracking-tighter text-white text-6xl md:text-8xl lg:text-[9vw]">
              Roll Up.<br /><span className="text-stroke">Press Play.</span>
            </h2>
          </div>
          <a
            data-testid="footer-subscribe"
            href={LABEL.channel}
            target="_blank"
            rel="noreferrer"
            className="group flex items-center gap-4 bg-signal text-void pl-6 pr-6 py-5 hover:bg-white transition-colors self-start"
          >
            <Youtube size={22} />
            <span className="font-mono uppercase tracking-[0.2em] text-xs">Subscribe on YouTube</span>
          </a>
        </div>

        <div className="flex flex-col md:flex-row md:items-center justify-between gap-8 pt-10 border-t border-white/10">
          <div className="flex items-center gap-6">
            <a data-testid="footer-yt" href={LABEL.channel} target="_blank" rel="noreferrer" className="text-white/50 hover:text-signal transition-colors"><Youtube size={20} /></a>
            <a data-testid="footer-ig" href={LABEL.instagram} target="_blank" rel="noreferrer" className="text-white/50 hover:text-signal transition-colors"><Instagram size={20} /></a>
            <a data-testid="footer-tt" href={LABEL.tiktok} target="_blank" rel="noreferrer" className="text-white/50 hover:text-signal transition-colors"><Music2 size={20} /></a>
          </div>
          <p className="font-mono uppercase tracking-[0.2em] text-[10px] text-white/40">
            {LABEL.est} (P) {LABEL.name}, LLC — All rights reserved
          </p>
          <p className="font-mono uppercase tracking-[0.2em] text-[10px] text-white/40">Lyrics & visuals for entertainment only 💨</p>
        </div>
      </div>
    </footer>
  );
};
